import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Hash } from "lucide-react";
import { api, BACKEND_URL } from "../../lib/api";

const file = (p) => `${BACKEND_URL}/api/files/${p}`;

export function TrendStrip() {
  const [g, setG] = useState(null);
  useEffect(() => { api.get("/public/invite-photos?limit=16").then((r) => setG(r.data)).catch(() => {}); }, []);
  if (!g) return null;
  const photos = g.photos;
  const loop = photos.length >= 4 ? [...photos, ...photos] : photos;
  return (
    <section className="bg-[var(--ink)] text-white py-8 overflow-hidden" data-testid="trend-strip">
      <div className="max-w-7xl mx-auto px-6 flex flex-wrap items-end justify-between gap-4 mb-5">
        <div>
          <p className="flex items-center gap-1 font-serif text-3xl"><Hash className="w-6 h-6 text-[var(--gold)]" />lockedinforever</p>
          <p className="text-xs text-white/60 mt-1">Couples looking at their invite on their phone. Share yours for {g.bonus_votes} bonus contest votes.</p>
        </div>
        <Link to="/invite-trend" className="btn-gold !py-2 text-sm inline-flex items-center gap-2" data-testid="trend-strip-cta">{photos.length ? "See the gallery" : "Be the first couple"} <ArrowRight className="w-4 h-4" /></Link>
      </div>
      {photos.length > 0 && (
        <div className={`flex gap-4 px-6 w-max ${photos.length >= 4 ? "animate-[trend-marquee_60s_linear_infinite] hover:[animation-play-state:paused]" : ""}`}>
          {loop.map((p, i) => (
            <Link key={`${p.photo_id}-${i}`} to="/invite-trend" className="shrink-0 w-40 md:w-52 group" data-testid={i < photos.length ? `trend-strip-photo-${p.photo_id}` : undefined} aria-hidden={i >= photos.length}>
              <div className="aspect-[4/5] rounded-2xl overflow-hidden ring-1 ring-white/10"><img src={file(p.image)} alt={p.couple_names} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
              <p className="text-xs mt-2 text-white/80 truncate">{p.couple_names}</p>
            </Link>
          ))}
        </div>
      )}
      <style>{"@keyframes trend-marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}"}</style>
    </section>
  );
}
